export default __webpack_public_path__ + "media/images/amenities/clothes_hanger-452b0f78f18b0cdbfb312234ce38c42b.jpeg";